import { FC, Fragment, useEffect, useState } from 'react';
import IResult from 'models/Result';
import ResultItem from './ResultItem';
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import { buildUserName } from 'utilities/Utilities';
import { PAGE_SIZE, REFRESH_INTERVAL_MS } from './constants';
import classes from './styles.module.css';

const ResultsList:FC = () => {
  const result:any = useAppSelector(selectResult);
  const results:IResult[] = result?.results || [];
  const spotPrizeWinnerResult = result?.spotPrizeWinnerResult;

  const pageCount = Math.ceil(results.length / PAGE_SIZE) || 1;
  const isPaginated = pageCount > 1;
  const [page, setPage] = useState<number>(0);

  useEffect(() => {
    if (!isPaginated) return;
    const rotationInterval = setInterval(() => {
      setPage((currentPage) => (currentPage + 1) % pageCount);
    }, REFRESH_INTERVAL_MS);
    return () => clearInterval(rotationInterval);
  }, [isPaginated, pageCount]);

  useEffect(() => {
    if (page >= pageCount) setPage(0);
  }, [page, pageCount]);

  if (!results.length) return null;

  const pageStart = isPaginated ? page * PAGE_SIZE : 0;
  const pageResults = isPaginated ? results.slice(pageStart, pageStart + PAGE_SIZE) : results;

  return (
    <div
      className="relative overflow-hidden  rounded-3xl w-full mb-4 pt-6 sm:mb-8 shadow-primary-border"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
    >
      <div key={page} className={isPaginated ? classes.pageFade : ''}>
        {pageResults.map((result, index) => (
          <ResultItem key={buildUserName(result)} result={result} resultIndex={pageStart + index} />
        ))}
      </div>
      {spotPrizeWinnerResult ? (
        <Fragment>
          <div className="shadow-primary-border h-1 my-4" />
          <ResultItem key={buildUserName(spotPrizeWinnerResult)} result={spotPrizeWinnerResult} resultIndex={10} randomPrize />
        </Fragment>
      ) : null}
    </div>
  )
}

export default ResultsList;
